import { useEffect, useState } from "react";
import API from "../../lib/api";
import { CalendarBlank, CaretLeft, CaretRight } from "@phosphor-icons/react";
import { Section } from "./hrUtils";
import { AbsenceGrid } from "./AbsenceGrid";

const month = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
const shift = (m, n) => { const [y, mm] = m.split("-").map(Number); return month(new Date(y, mm - 1 + n, 1)); };
const monthLabel = (m) => { const [y, mm] = m.split("-").map(Number); return new Date(y, mm - 1, 1).toLocaleDateString("en-GB", { month: "long", year: "numeric" }); };

/** My HR: a line manager's month grid of just their own team's leave, sickness and bank holidays. Hidden for people with no reports. */
export function TeamCalendarCard() {
  const [m, setM] = useState(month(new Date()));
  const [cal, setCal] = useState(null);
  const [gone, setGone] = useState(false);
  useEffect(() => {
    let live = true;  // ignore responses from a month the user has already moved away from
    API.get("/hr/team/calendar", { params: { month: m } }).then((r) => { if (live) setCal(r.data); }).catch((e) => { if (live && e?.response?.status === 404) setGone(true); });
    return () => { live = false; };
  }, [m]);
  if (gone || !cal) return null;
  return (
    <Section title={`Team calendar — ${monthLabel(cal.month || m)}`} icon={CalendarBlank} testid="my-team-calendar" action={
      <div className="flex items-center gap-1"><button onClick={() => setM(shift(m, -1))} className="h-7 w-7 rounded border border-border" aria-label="Previous month" data-testid="my-team-cal-prev"><CaretLeft size={14} className="mx-auto" /></button><button onClick={() => setM(shift(m, 1))} className="h-7 w-7 rounded border border-border" aria-label="Next month" data-testid="my-team-cal-next"><CaretRight size={14} className="mx-auto" /></button></div>
    }>
      <AbsenceGrid cal={cal} />
      {cal.not_on_payroll?.length > 0 && <p className="mt-2 text-[11px] text-muted-foreground" data-testid="my-team-cal-unlinked">Not on the grid (no payroll link yet): {cal.not_on_payroll.join(", ")}</p>}
    </Section>
  );
}
